import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { createBrowserHistory } from "history";

const browserHistory = createBrowserHistory({ basename: '' });

const clickPluginInstance = new ClickAnalyticsPlugin();
// Click Analytics configuration
const clickPluginConfig = {
  autoCapture: true
};

const instrumentationKey = process.env.REACT_APP_APPINSIGHTS_KEY;

const reactPlugin = new ReactPlugin();
const configObj = {
  connectionString: 'InstrumentationKey=' + instrumentationKey + ';IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
  enableAutoRouteTracking: true,
  extensions: [reactPlugin, clickPluginInstance], // Add the click plugin to the extensions array
  extensionConfig: {
    [reactPlugin.identifier]: { history: browserHistory },
    [clickPluginInstance.identifier]: clickPluginConfig, // Add the click plugin config
  },
};

const appInsights = new ApplicationInsights({ config: configObj });

appInsights.loadAppInsights();
appInsights.trackPageView();

export { reactPlugin, appInsights, clickPluginInstance };